module.exports = __webpack_public_path__ + "static/img/welfareDetails.118268d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/welfareDetails.png
// module id = O4jC
// module chunks = 1